import React, { useEffect, useRef, useState } from "react";
import { Avatar, Box, Divider, Grid2, List, ListItem, ListItemAvatar, ListItemIcon, ListItemText, MenuItem, Select, styled, Tab, Tabs, Typography, useTheme } from "@mui/material";
import Highcharts from 'highcharts';
import HighchartsReact from 'highcharts-react-official';
import { useParams } from "react-router-dom";
import dayjs from "dayjs";
import { Skeleton } from '@mui/material';
import isSameOrBefore from 'dayjs/plugin/isSameOrBefore';
import MilestonesPopup from "./MilestonesPopup";
import { useGetOntimeVsDelayedQuery } from "store/slices/apis/scheduleDashboarSlice";
import moment from "moment";
//dayjs.extend(isSameOrBefore);

const MilestonesBarChart = () => {
    const theme = useTheme();
    const { projectId } = useParams();
    const [popupOpen, setPopupOpen] = useState(false);
    const [selectedMilestone, setSelectedMilestone] = useState(null);
    const { data, isLoading } = useGetOntimeVsDelayedQuery({ projectId });
    const milestoneData = data?.data
    const filteredData = Array.isArray(milestoneData)
        ? milestoneData.filter(item =>
            moment(item.month, "MMM-YYYY")
        )
        : [];
        console.log(filteredData);
        
    const handleBarClick = (event) => {
        const point = event.point;
        const category = point.category;
        const clickedMonth = dayjs(category, 'MMM,YY').startOf('month');
        const milestone = milestoneData.find(m =>
            dayjs(m.month).isSame(clickedMonth, 'month')
        );


        if (milestone) {
            setSelectedMilestone(milestone);
            setPopupOpen(true);
        }
    };

    const options = {
        chart: {
            type: 'column',
            height: 300,
        },
        title: {
            text: null,
        },
        xAxis: {
            categories: filteredData?.map(item =>
                moment(item.month).format('MMM,YY')
            ),
            title: {
                text: "Months",
            },
            crosshair: true,
            labels: {
                style: {
                    fontSize: '12px',
                }
            }
        },
        yAxis: {
            min: 0,
            title: {
                text: "No Of Milestones",
            },
            labels: {
                format: '{value}',
            },
        },
        plotOptions: {
            column: {
                borderRadius: 4,
                pointPadding: 0.2,
                borderWidth: 0,
                cursor: 'pointer',
                point: {
                    events: {
                        click: handleBarClick,
                    }
                }
            }
        },
        series: [
            {
                name: 'Delayed',
                color: '#E72B33',
                data: filteredData?.map(item => ({
                    y: item.delayed ?? 0,
                    month: item.month,
                    events: {
                        click: function () {
                            const milestone = milestoneData.find(m => m.month === item.month);
                            if (milestone) {
                                setSelectedMilestone(milestone);
                                setPopupOpen(true);
                            }
                        }
                    }
                })),
            },
            {
                name: 'On-time',
                color: '#295477',
                data: filteredData?.map(item => ({
                    y: item.ontime ?? 0,
                    month: item.month,
                    events: {
                        click: function () {
                            const milestone = milestoneData.find(m => m.month === item.month);
                            if (milestone) {
                                setSelectedMilestone(milestone);
                                setPopupOpen(true);
                            }
                        }
                    }
                })),
            }
        ],
        credits: {
            enabled: false,
        },
        legend: {
            enabled: true,
            layout: 'horizontal',
            align: 'left',
            verticalAlign: 'top',
            itemStyle: {
                fontSize: '15px',
            },
            symbolRadius: 0,
            symbolHeight: 13,
            symbolWidth: 13,
            itemMarginBottom: 20,
            margin: 20,
        },
    };
    return (
        <Box sx={{ padding: 2, border: '1px solid #2525252E', borderRadius: '7px', background: "#FFFFFF", minHeight: "470px" }}>
            <Grid2 container>
                <Grid2 size={{ xs: 12, md: 12 }}>
                    <Typography variant="h6" sx={{ fontWeight: "500", fontSize: '18px', color: `#182A4E`, lineHeight: '100%', letterSpacing: '-0.4px' }}>
                        Milestones
                    </Typography>
                    {/* <Typography variant="caption" sx={{ fontWeight: "500", fontSize: '16px', color: `#182A4E80`, lineHeight: '100%', letterSpacing: '-0.4px' }}>
                        Get a hollistic view of how work is being priotised
                    </Typography> */}
                    <Grid2 container spacing={1}>
                        <Grid2 size={12}>
                            <Box sx={{ borderBottom: 0, borderColor: 'divider' }}>
                                {isLoading ? (
                                    <Skeleton variant="rectangular" width="100%" height={300} animation="wave" />
                                ) : (
                                    <HighchartsReact highcharts={Highcharts} options={options} />
                                )}
                            </Box>
                        </Grid2>
                    </Grid2>
                </Grid2>
            </Grid2>
            <MilestonesPopup
                title={dayjs(selectedMilestone?.month).format('MMM,YYYY')}
                value={selectedMilestone?.delayed}
                status={"Static View"}
                onClose={() => setPopupOpen(false)}
                onOpen={popupOpen}
                data={[
                    {
                        milestone_number: "MS-001",
                        milestone_name: "Foundation Complete",
                        plan_date: "2024-05-15",
                        actual_date: "2024-05-17",
                    },
                    {
                        milestone_number: "MS-002",
                        milestone_name: "Structure Ready",
                        plan_date: "2024-06-10",
                        actual_date: "2024-06-12",
                    }
                ]}
            />
        </Box >
    );
};

export default MilestonesBarChart;